// pliki z lokalnymi tłumaczeniami

import enTranslations from './en.json';
import plTranslations from './pl.json';

export const localResources = {
  en: {
    translation: enTranslations
  },
  pl: {
    translation: plTranslations
  }
};



